import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Modal, Table, Popover} from 'antd'
import {Link} from 'react-router-dom'

class OrdersSameInfoNotDesign extends Component {
    state = {
        visible: false
    }

    _showModal = () => {
        this.setState({visible: true})
    }

    _hideModal = () => {
        this.setState({
            visible: false
        })
    }

    _renderPreviewImage = (url) => {
        if (!url) return ''
        
        return (
            <Popover
                trigger="hover"
                placement="right"
                content={
                    <img
                        src={url}
                        alt="preview"
                        style={{
                            // maxWidth: 800,
                            maxHeight: 'calc(100vh - 50px)',
                            // objectFit: 'contain'
                        }}
                    />
                }
                overlayClassName={`previewFixed`}
            >
                <img
                    src={url}
                    alt="preview-thumb"
                    style={{
                        width:150,
                        height: 150,
                        objectFit: 'cover',
                        border: '1px solid #ddd',
                        borderRadius: 4,
                        cursor: 'pointer'
                    }}
                />
            </Popover>
        )
    }

    render() {
        const {listBarcode} = this.props
        const {visible} = this.state

        const tableData = listBarcode.map((item, index) => ({
            key: index,
            design: item.preview_image,
            ordersSameDesign: item.orders && item.orders.length
            ? item.orders.join(", ")
            : "—"
        }))

        const columns = [
            {
                title: "Design",
                dataIndex: "design",
                key: "design",
                width: "20%",
                render: (design) => this._renderPreviewImage(design)
            },
            {
                title: "Barcode cùng thông tin thêu chưa thiết kế",
                dataIndex: "ordersSameDesign",
                key: "ordersSameDesign",
                width: "80%",
                render: (text) => {
                    if (!text || text === "—") return "—";

                    const items = text.split(",").map(s => s.trim());

                    return (
                        <div>
                            {items.map((code, idx) => (
                                <React.Fragment key={idx}>
                                    <Link to={`/order-item?template=${code}`} target="_blank">
                                        #{code}
                                    </Link>
                                    {idx < items.length - 1 ? ", " : ""}
                                </React.Fragment>
                            ))}
                        </div>
                    );
                }
            }
        ]

        return (
            <div className='BarcodeSameInfoNotDesign'>
                <Button onClick={this._showModal} className='mr-2'>Ds barcode cùng thông tin thêu chưa thiết kế</Button>

                <Modal
                    className="ModalListBarcodeSameInfoNotDesign"
                    visible={visible}
                    title="Danh sách barcode cùng thông tin thêu chưa thiết kế"
                    onCancel={this._hideModal}
                    footer={[
                        <Button key="back" onClick={this._hideModal}>
                            Cancel
                        </Button>
                    ]}
                    width={1200}
                    // style={{ top: 20 }}
                >
                    <div className="ListBarcodeContainer">
                        <Table columns={columns} dataSource={tableData} pagination={false} />
                    </div>
                </Modal>
            </div>
        )
    }
}

export default OrdersSameInfoNotDesign
